// 连接类型
export const UPLOAD_STATUS = {
    READY: 'ready',
    UPLOADED: 'uploaded',
    DONE: 'done',
    FAILED: 'failed',
    PROCESSING: 'processing',
    COMPILING: 'compiling',
    COMPILE_FAILED: 'compileFailed'
};